// extracted by mini-css-extract-plugin
export default {"swiperslide":"DaySelector_swiperslide__xYPGy","swiperStyles":"DaySelector_swiperStyles__I2mvA"};